/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const notificationJobs = sqliteTable('notification_jobs', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  channel: text('channel'),
  template_id: text('template_id'),
  patient_id: text('patient_id'),
  to_phone_e164: text('to_phone_e164'),
  to_market: text('to_market'),
  scheduled_at: text('scheduled_at'),
  next_attempt_at: text('next_attempt_at'),
  status: text('status'),
  attempts: integer('attempts'),
  max_attempts: integer('max_attempts'),
  last_error: text('last_error'),
  client_reference: text('client_reference'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
